import moment from 'moment'
import { SkudVisitEndpoint } from '@/views/skud/shared/endpoint_services/skud-visit-endpoint-service'
import { VisitState, VisitParticipantState, visitStateColor, enumText } from '@/views/skud/shared/models/enums'

const DATE_FMT = 'DD.MM.YYYY HH:mm'

function fmt (v) {
  return v ? moment(v).format(DATE_FMT) : null
}

function decodeParticipant (p) {
  return Object.assign({}, p, {
    state_text: enumText(VisitParticipantState, p.state)
  })
}

function decodeVisit (x) {
  if (!x) return x
  return Object.assign({}, x, {
    state_text: enumText(VisitState, x.state),
    state_color: visitStateColor(x.state),
    starts_at: fmt(x.starts_at),
    ends_at: fmt(x.ends_at),
    confirmed_at: fmt(x.confirmed_at),
    side_text: x.side === 'from' ? 'Исходящий' : (x.side === 'to' ? 'Входящий' : x.side),
    participants: x.participants ? x.participants.map(decodeParticipant) : x.participants
  })
}

export class SkudVisitService {
  constructor () {
    this.endpoint = new SkudVisitEndpoint()
  }

  // Мутации возвращают {ok:true,data}|{ok:false,error} как есть.
  async createVisit (placeId, body) {
    return this.endpoint.createVisit(placeId, body)
  }

  async submitVisit (placeId, visitId, comment) {
    return this.endpoint.submitVisit(placeId, visitId, comment)
  }

  async confirmVisit (placeId, visitId, body) {
    return this.endpoint.confirmVisit(placeId, visitId, body)
  }

  async rejectVisit (placeId, visitId, reason) {
    return this.endpoint.rejectVisit(placeId, visitId, reason)
  }

  async cancelVisit (placeId, visitId, reason) {
    return this.endpoint.cancelVisit(placeId, visitId, reason)
  }

  // -> {items, next_cursor_visit_id} или null.
  async getVisits (placeId, params) {
    const res = await this.endpoint.getVisits(placeId, params)
    if (!res) return null
    return {
      items: (res.items || []).map(decodeVisit),
      next_cursor_visit_id: res.next_cursor_visit_id || null
    }
  }

  // -> объект визита (декодированный) или null.
  async getVisit (placeId, visitId) {
    const x = await this.endpoint.getVisit(placeId, visitId)
    return decodeVisit(x)
  }
}
